import React from "react";
import { Link } from "react-router-dom";

const Profile = () => {
    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <div className="row align-items-center">
                        <div className="col-sm-5">
                            <h4 className="card-title mb-0"> Users</h4>
                        </div>
                        <div className="col-sm-7">
                            <div className="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                                <Link to="/admin/user/add" className="btn btn-success ml-1" data-toggle="tooltip" title="Create New" data-original-title="Create New"><i className="fa fa-plus-circle"></i> Add More</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                            <thead>
                                <tr>
                                    <th>Sr.No.</th>
                                    <th>User Name</th>
                                    <th>Email</th>
                                    <th>Packages</th>
                                    <th>Status</th>
                                    <th>Created At</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr>
                                    <td>1</td>
                                    <td>Surya Mishra</td>
                                    <td>Suryamishra@gmail.com</td>
                                    <td>Subscription</td>
                                    <td>Active</td>
                                    <td>20/71994</td>
                                    <td className="list-action-sec">
                                        <Link to="#" className="btn btn-info btn-circle btn-sm mr-2" title="View user details">
                                            <i className="fa fa-eye"></i>
                                        </Link>
                                        <Link to="#" className="btn btn-warning btn-circle btn-sm mr-2">
                                            <i className="fas fa-edit"></i>
                                        </Link>
                                        <form method="post" action="#">
                                            <button type="submit" className="btn btn-danger btn-circle btn-sm">
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </form>
                                    </td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>Surya Mishra</td>
                                    <td>Suryamishra@gmail.com</td>
                                    <td>Subscription</td>
                                    <td>Active</td>
                                    <td>20/71994</td>
                                    <td className="list-action-sec">
                                        <Link to="#" className="btn btn-info btn-circle btn-sm mr-2" title="View user details">
                                            <i className="fa fa-eye"></i>
                                        </Link>
                                        <Link to="#" className="btn btn-warning btn-circle btn-sm mr-2">
                                            <i className="fas fa-edit"></i>
                                        </Link>
                                        <form method="post" action="#">
                                            <button type="submit" className="btn btn-danger btn-circle btn-sm">
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </form>
                                    </td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile;